import styled from 'styled-components'
import { TabsUnstyled } from 'Components/Tabs/unstyled'

export const Tabs = styled(TabsUnstyled)`
  background-color: ${props => props.theme.colors.white};

  ul {
    border: none;
    padding: 15px 35px 0 35px;

    li {
      & > a {
        font-size: ${props => props.theme.fontSizes.tabs.tab};
        color: ${props => props.theme.colors.regentGray2};
      }

      & > a,
      &.active > a,
      &.active > a:focus,
      &.active > a:hover {
        border: none;
      }

      &.active,
      &:hover {
        &:after {
          content: '';
          display: block;
          position: absolute;
          width: 100%;
          height: 2px;
          bottom: 0;
          background-color: ${props => props.theme.colors.primary};
        }
      }

      &:hover > a {
        background: transparent;
      }

      &.active > a,
      &.active > a:focus {
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Tabs/index.js